import { FormSelect } from 'components/form-fields';
import { useValidation } from 'hooks/useValidation';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { Fragment, useEffect } from 'react';

export function OcrSelectLayout(
    {
        loading = false,
        disabled = false,
        readonly = false,
        items,
        layout,
        onChange,
        placeholder
    }
) {
    const [_, errors, validate] = useValidation();

    useEffect(() => {
        validateLayout();
    }, [layout.answer]);

    function validateLayout() {
        const required = layout.requiredAnswerCount > 0;
        const rules = [{ fieldName: 'answer', required: required }];
        validate(rules, layout);
    }

    function onValueChange(value) {
        const clonedLayout = { ...layout };

        clonedLayout.answer = value.id;

        onChange(clonedLayout);
    }

    function itemName() {
        var name = '';
        if (items) {
            var matchedItem = items.find(o => o.id === layout.answer);

            if (matchedItem) {
                name = matchedItem.name;
            }
        }
        return name;
    }

    return (
        <Fragment>
            <div className={classNames({ "hide-in-print": !readonly, "hidden": readonly })}>
                <FormSelect
                    loading={loading}
                    onItemSelect={onValueChange}
                    items={items}
                    selectedValue={layout.answer}
                    placeholder={placeholder}
                    headingText={layout.secondaryLayoutTitle ? layout.secondaryLayoutTitle : ''}
                    disabled={disabled}
                    dangerHelperText={errors.answer}
                />
            </div>
            <div className={classNames({ "show-in-print": !readonly, "visible": readonly })}>
                <h4 className={classNames({ "bp6-skeleton": loading })}>{layout.secondaryLayoutTitle ? layout.secondaryLayoutTitle : ''}</h4>
                <p className={classNames({ "bp6-skeleton": loading })}>{itemName()}</p>
            </div>
        </Fragment>
    );

}

OcrSelectLayout.propTypes = {
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool
};
